import React from 'react';

import { Checkbox, CheckboxProps } from './Checkbox';
import { FormField, FormFieldPropsWithoutChildren } from './FormField';

export type FormCheckboxInputProps = CheckboxProps &
  FormFieldPropsWithoutChildren & {
    labelPlacement?: 'stacked' | 'inline';
    'data-block-id'?: string;
    'data-block-type'?: string;
  };

export function FormCheckboxInput({
  label,
  helpText,
  error,
  isRequired,
  id,
  labelActions,
  inputActions,
  labelPlacement = 'inline',
  classes,
  className,
  'data-block-id': dataBlockId,
  'data-block-type': dataBlockType,
  ...checkboxProps
}: FormCheckboxInputProps) {
  return (
    <FormField
      labelPlacement={labelPlacement}
      label={label}
      helpText={helpText}
      error={error}
      isRequired={isRequired}
      id={id}
      labelActions={labelActions}
      inputActions={inputActions}
      classes={classes ?? className}
      data-block-id={dataBlockId}
      data-block-type={dataBlockType}
    >
      <Checkbox {...checkboxProps} />
    </FormField>
  );
}
